import {
  AlphaSemantic_getInstance2fqb49tln9c5i as AlphaSemantic_getInstance,
  get_alphaThemewmx34wledr33 as get_alphaTheme,
} from '../../theming/files.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { Constant5dc3leeorpdb as Constant } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  timesx4ey3un7ihw1 as times,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  divkhq3vjih9fcw as div,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_atBottomzb604i67rgu3 as get_atBottom,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { renderFilePreview3fl8uuiu4tdzl as renderFilePreview } from './renderFiles.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_px1lajc6xaddk2r as get_px_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.js.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  flatLens32lsgpliumxw4 as flatLens,
} from '../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance } from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_tertiaryButton1h22y4lorv47t as get_tertiaryButton } from '../../theming/buttons.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
} from './attachmentFilePreview.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  minus1djrl64vbav3y as minus,
  plus310ted5e4i90h as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { fileName15g5pzin3s3wj as fileName } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FileManagerSemantic$default$lambda($this$to, it) {
  return it.ab1_1;
}
function FileManagerSemantic$default$lambda_0($this$to, it) {
  return $this$to.kd1(it, false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.db1(AlphaSemantic_getInstance()).eb1_1.ob0_1, get_dp(2)).zb0_1;
}
var FileManagerSemanticClass;
function FileManagerSemantic() {
  if (FileManagerSemanticClass === VOID) {
    class $ extends Semantic() {
      static bge() {
        FileManagerSemantic_instance = null;
        var $this = this.bd1('flmgr');
        FileManagerSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp0_outlineWidth = get_dp(0);
        var tmp1_background = AppColors_getInstance().ffz_1.zg9_1.ccz(0.0);
        var tmp2_outline = Companion_getInstance().qaz_1;
        var tmp3_cornerRadii = new (Constant())(get_px(0));
        var tmp = SelectedSemantic_getInstance();
        var tmp_0 = to(tmp, FileManagerSemantic$default$lambda);
        var tmp_1 = CardSemantic_getInstance();
        var tmp4_derivations = mapOf([tmp_0, to(tmp_1, FileManagerSemantic$default$lambda_0)]);
        return this.ed1(theme, VOID, VOID, VOID, tmp3_cornerRadii, VOID, VOID, VOID, VOID, tmp2_outline, tmp0_outlineWidth, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'FileManagerSemantic';
      }
      hashCode() {
        return 768763122;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FileManagerSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FileManagerSemantic');
    FileManagerSemanticClass = $;
  }
  return FileManagerSemanticClass;
}
var FileManagerSemantic_instance;
function FileManagerSemantic_getInstance() {
  if (FileManagerSemantic_instance === VOID)
    FileManagerSemantic().bge();
  return FileManagerSemantic_instance;
}
function fileManager(_this__u8e3s4, files, emptyText, mimeTypes, size, uploader) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  size = size === VOID ? get_AppDimensions().qg2_1 : size;
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, times(size, 1.2));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_AppDimensions().ig2_1);
  // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
  var action = fileManager$slambda_0(files, uploader);
  // Inline function 'kotlin.also' call
  var this_0 = new (ReactiveContextSuspending())(view, VOID, VOID, action);
  this_0.yai();
  var tmp0_safe_receiver = view.ea2().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cah(this_0);
  }
  var tmp_0 = view.ibb(get_expanding(view), view.hbb(FileManagerSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1 = get_scrollingHorizontally(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  forEachUpdating(view_1, files, VOID, ($this$forEachUpdating, file) => {
    var tmp = sizeConstraints($this$forEachUpdating, VOID, VOID, VOID, VOID, VOID, size, times(size, 1.2));
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var tmp$ret$3 = $this$forEachUpdating.hbb(CardSemantic_getInstance());
    var tmp_0 = $this$forEachUpdating.ibb(tmp, tmp$ret$3);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Frame())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.ebb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var $this$preview = view_0;
    reactiveScope($this$preview, ($this$reactiveScope) => {
      $this$preview.zb9();
      var filePreview = $this$reactiveScope.baj(file).agc_1;
      get_centered($this$preview);
      renderFilePreview($this$preview, filePreview, size);
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance_1();
      return Unit_instance;
    });
    view.fbb(p_0, view_0);
    var tmp_1 = view.ibb(get_atTopEnd(view), get_alphaTheme(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.eba(get_rem(0.25));
    icon(view_1, resize(Companion_getInstance_0().tcf_1, times(get_rem_0(2), get_px_0(size) / get_px_0(get_AppDimensions().qg2_1))), 'Remove File');
    onClick(view_1, VOID, VOID, fileManager$lambda$slambda_0(file, files));
    view.fbb(p_1, view_1);
    view.jbb(tmp_1, view_1);
    var tmp_2 = view.ibb(get_atBottom(view), get_alphaTheme(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextInput())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    var value = 'File Name';
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    view_2.tb5_1.zb3_1.ib7_1.placeholder = value;
    view_2.xah(view_2.gcn_1, flatLens(file, fileManager$lambda$lambda));
    view.fbb(p_2, view_2);
    view.jbb(tmp_2, view_2);
    $this$forEachUpdating.fbb(p, view);
    $this$forEachUpdating.jbb(tmp_0, view);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_1, view_1);
  var tmp_2 = get_centered(view_0);
  var tmp_3 = view_0.ibb(view_0.ibb(tmp_2, shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(files).i1())), view_0.hbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_4 = view_2.tb5_1;
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(emptyText) === 0) {
    tmp_5 = '\xA0';
  } else {
    tmp_5 = emptyText;
  }
  tmp_4.fbu(tmp_5);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_3, view_2);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_6 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, div(get_AppDimensions().qg2_1, 3)), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  view_3.jbb(get_centered(view_3), icon(view_3, Companion_getInstance_0().wcf_1, 'Add File'));
  onClick(view_3, VOID, VOID, fileManager$slambda_2(view_3, mimeTypes, files));
  view.fbb(p_3, view_3);
  view.jbb(tmp_6, view_3);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function fileCarousel(_this__u8e3s4, files, emptyText, size, setup) {
  emptyText = emptyText === VOID ? 'Nothing Yet' : emptyText;
  size = size === VOID ? get_AppDimensions().qg2_1 : size;
  var tmp;
  if (setup === VOID) {
    tmp = fileCarousel$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  var tmp_0 = _this__u8e3s4.ibb(sizeConstraints(_this__u8e3s4, VOID, VOID, size), _this__u8e3s4.hbb(FileManagerSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  setup(view);
  var tmp_1 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(files).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_dp(8));
  forEachUpdating(view_0, files, VOID, ($this$forEachUpdating, file) => {
    var tmp = sizeConstraints($this$forEachUpdating, VOID, VOID, VOID, VOID, VOID, size, size);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Frame())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.ebb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var $this$image = view_0;
    reactive($this$image, ($this$reactive) => {
      $this$image.zb9();
      renderFilePreview($this$image, $this$reactive.baj(file).agc_1, size);
      return Unit_instance;
    });
    view.fbb(p_0, view_0);
    var tmp_0 = view.ibb(get_atTopEnd(view), get_alphaTheme(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.eba(get_rem(0.25));
    icon(view_1, resize(Companion_getInstance_0().tcf_1, get_rem_0(2)), 'Remove File');
    onClick(view_1, 'Remove File', VOID, fileCarousel$lambda$slambda_0(files, file));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
    var tmp_1 = view.ibb(view.ibb(get_atBottom(view), get_alphaTheme(view)), get_compact(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextInput())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    var value = 'File Name';
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    view_2.tb5_1.zb3_1.ib7_1.placeholder = value;
    view_2.xah(view_2.gcn_1, flatLens(file, fileCarousel$lambda$lambda));
    view.fbb(p_2, view_2);
    view.jbb(tmp_1, view_2);
    $this$forEachUpdating.fbb(p, view);
    $this$forEachUpdating.jbb(tmp, view);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp_1, view_0);
  var tmp_2 = view.ibb(view.ibb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(files).i1()), get_centered(view)), view.hbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_3 = view_1.tb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(emptyText) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = emptyText;
  }
  tmp_3.fbu(tmp_4);
  view.fbb(p_1, view_1);
  view.jbb(tmp_2, view_1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_0, view);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.cge_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0;
    var tmp_1 = element.agc_1;
    if (tmp_1 instanceof LocalFile()) {
      tmp_0 = element.agc_1.mgb_1 == null;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      destination.v(element);
    }
  }
  var l = destination;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = l.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    $l$block: {
      var tmp_2 = element_0.agc_1;
      var tmp0_elvis_lhs = tmp_2 instanceof LocalFile() ? tmp_2 : null;
      var tmp_3;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp_3 = tmp0_elvis_lhs;
      }
      var preview = tmp_3;
      var tmp_4 = $this.dge_1($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp_5 = preview.xgb(tmp_4, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
    }
  }
  return Unit_instance;
}
var fileManager$slambdaClass;
function fileManager$slambda() {
  if (fileManager$slambdaClass === VOID) {
    class $ {
      constructor($files, $uploader) {
        this.cge_1 = $files;
        this.dge_1 = $uploader;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    fileManager$slambdaClass = $;
  }
  return fileManager$slambdaClass;
}
function fileManager$slambda_0($files, $uploader) {
  var i = new (fileManager$slambda())($files, $uploader);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = await_0($this.ege_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var removed = tmp;
  var tmp_0 = await_0($this.fge_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var f = tmp_0;
  var new_0 = minus(f, removed);
  var tmp_1 = $this.fge_1.gah(new_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var fileManager$lambda$slambdaClass;
function fileManager$lambda$slambda() {
  if (fileManager$lambda$slambdaClass === VOID) {
    class $ {
      constructor($file, $files) {
        this.ege_1 = $file;
        this.fge_1 = $files;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    fileManager$lambda$slambdaClass = $;
  }
  return fileManager$lambda$slambdaClass;
}
function fileManager$lambda$slambda_0($file, $files) {
  var i = new (fileManager$lambda$slambda())($file, $files);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function fileManager$lambda$lambda(it) {
  return it.zgb_1;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = await_0($this.gge_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var f = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.hge_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (FileData())(VOID, Signal().fak(fileName(item)), new (LocalFile())(item), new (LocalFile())(item));
    destination.v(tmp$ret$0);
  }
  var tmp_0 = $this.gge_1.gah(plus(f, destination), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = requestFiles($this.ige_1.pc(), $this.jge_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.let' call
  var results = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!results.i1()) {
    launch($this.ige_1, VOID, VOID, fileManager$slambda$slambda_0($this.kge_1, results));
  }
  return Unit_instance;
}
var fileManager$slambda$slambdaClass;
function fileManager$slambda$slambda() {
  if (fileManager$slambda$slambdaClass === VOID) {
    class $ {
      constructor($files, $results) {
        this.gge_1 = $files;
        this.hge_1 = $results;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    fileManager$slambda$slambdaClass = $;
  }
  return fileManager$slambda$slambdaClass;
}
function fileManager$slambda$slambda_0($files, $results) {
  var i = new (fileManager$slambda$slambda())($files, $results);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var fileManager$slambdaClass_0;
function fileManager$slambda_1() {
  if (fileManager$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $mimeTypes, $files) {
        this.ige_1 = $$this$button;
        this.jge_1 = $mimeTypes;
        this.kge_1 = $files;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    fileManager$slambdaClass_0 = $;
  }
  return fileManager$slambdaClass_0;
}
function fileManager$slambda_2($$this$button, $mimeTypes, $files) {
  var i = new (fileManager$slambda_1())($$this$button, $mimeTypes, $files);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function fileCarousel$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lge_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return minus(it, tmp$ret$0);
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.mge_1;
  var tmp0_safe_receiver = tmp instanceof ReactiveMutableList() ? tmp : null;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.nge_1;
    var tmp_1 = await_0(this_0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$0 = tmp_1;
    tmp_0 = tmp0_safe_receiver.kam(tmp$ret$0);
  }
  if (tmp_0 == null) {
    var tmp_2 = modify($this.mge_1, fileCarousel$lambda$slambda$slambda_0($this.nge_1), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var fileCarousel$lambda$slambda$slambdaClass;
function fileCarousel$lambda$slambda$slambda() {
  if (fileCarousel$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($file) {
        this.lge_1 = $file;
      }
      oge(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.oge((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    fileCarousel$lambda$slambda$slambdaClass = $;
  }
  return fileCarousel$lambda$slambda$slambdaClass;
}
function fileCarousel$lambda$slambda$slambda_0($file) {
  var i = new (fileCarousel$lambda$slambda$slambda())($file);
  var l = (it, $completion) => i.oge(it, $completion);
  l.$arity = 1;
  return l;
}
var fileCarousel$lambda$slambdaClass;
function fileCarousel$lambda$slambda() {
  if (fileCarousel$lambda$slambdaClass === VOID) {
    class $ {
      constructor($files, $file) {
        this.mge_1 = $files;
        this.nge_1 = $file;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    fileCarousel$lambda$slambdaClass = $;
  }
  return fileCarousel$lambda$slambdaClass;
}
function fileCarousel$lambda$slambda_0($files, $file) {
  var i = new (fileCarousel$lambda$slambda())($files, $file);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function fileCarousel$lambda$lambda(it) {
  return it.zgb_1;
}
//region block: exports
export {
  fileCarousel as fileCarousely0kamh1gns47,
  fileManager as fileManager1pvd5zvbyt8nt,
};
//endregion

//# sourceMappingURL=fileManager.mjs.map
